import React from "react";

const Instructions = ({ isNextPage }) => {
  return (
    <div className="p-10 mt-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <span className="text-xl font-bold text-blue-900">Instructions</span>
      <span className="text-gray-800">
        1. Students are responsible for keeping themselves informed about
        Regulations relating to studies and examinations at The University of
        Stavanger and other instructions relevent to their exam.
      </span>
      <span className="text-gray-800">
        2. Students are responsible for keeping themselves informed about exam
        dates, as well as the time and place of the examination.
      </span>
      <span className="text-gray-800">
        3. Candidates must be present in the exam room at least 30 minutes
        before the exam starts. If students arrive later than this when they
        have a digital exam, they will not be granted exam time if they do not
        get logged in on time for when the exam starts.
      </span>
      <span className="text-gray-800">
        4. During digital exams, Candidates must have their own laptop, cf,
        Regulations on payment for universities and colleges. Candidates are
        required to prepare their machine in advance of the exam. The machine
        must be of recent date and updated so that it can be used for exam
        completion.
      </span>
      <span className="text-gray-800">
        5. Indicate the Attempted questions, indicates the wrong question.
      </span>
      <span className="text-gray-800">
        6. Candidates must have a valid ID placed on their desk during the
        examination ex:- student card, driver license, passport, etc. Without a
        valid ID Candidates will not be admitted.
      </span>
      <div className="flex justify-center items-center">
        <button
          onClick={isNextPage}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Instructions;
